// extracted by mini-css-extract-plugin
export default {"map":"InspectMap_map__pZ-FE","inspect-state__wrapper":"InspectMap_inspect-state__wrapper__Mc8XU"};